// extracted by mini-css-extract-plugin
module.exports = {"triggerActivity":"JMwXg5yjSjknqi8ulxjW"};